import axiosInstance from "@/helpers/axios";

export default {
  namespaced: true,
  actions: {
    getAll({ dispatch, commit }, { type }) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .get(`/user-profiles?type=${type}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    getAllEmployers({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .get(`/user-profiles/all-employers`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
  },
};
